import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { isValid, parse } from "date-fns";

import { tableDatePickerProps } from "../utils/styles";

export default function ReferredDate({ initValue, onChange, isTableView = false }) {
  let parsedValue = null;

  if (initValue) {
    const temp = parse(initValue, "yyyy-MM-dd", new Date());
    parsedValue = isValid(temp) ? temp : null;
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label={isTableView ? "" : "Referral Date"}
        sx={isTableView ? tableDatePickerProps : {}}
        defaultValue={parsedValue ?? new Date()}
        onChange={(value) => {
          onChange("referredAt", value);
        }}
      />
    </LocalizationProvider>
  );
}
